import { smrApi } from '@/utils/axios-config'
import store from '@/store'

const apiBase = 'vibs';

export default {
    getAllRouteTrafficAlerts() {
        return smrApi.get(`${apiBase}/route-alert-configs`, {
            headers: {
                'x-forwarded-auth': `session:${store.getters.user.sessionToken}`
            }
        });
    },
    removeRouteTrafficAlert(id) {
        return smrApi.delete(`${apiBase}/route-alert-configs/${id}`, {
            headers: {
                'x-forwarded-auth': `session:${store.getters.user.sessionToken}`
            }
        });
    }
}